<template>
  <v-container fluid v-if="isAdmin || isManager">
    <!-- HEADER -->
    <!-- BP Selector -->
    <v-row dense class="d-flex">
      <v-col >
        <ViewTitle title="BP creator"/>
      </v-col>
      <v-col cols="2">
      </v-col>
      <v-col
        class="d-flex justify-end mb-0 pb-0 component"
        md="auto"
      >
        <v-btn icon @click="is_mobile= !is_mobile"><v-icon>{{is_mobile ? 'mdi-monitor' : 'mdi-tablet-cellphone' }}</v-icon></v-btn>
        <LangSelector @update="change_lang"/>
        <v-text-field
          :value="js_name"
          dense
          clearable
          @input="change_name"
          :disabled="normal_user"
        />
        <v-btn
          icon
          :disabled="!js_name || normal_user"
          @click="save_json"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-col>
      <v-col
        class="d-flex justify-end mb-0 pb-0 component"
        md="auto"
      >
        <v-btn
          v-if="readonly"
          icon
          :disabled="normal_user"
          @click="readonly = !readonly"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          @click="cancel"
        >
          <v-icon v-if="!readonly">mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col
        class="d-flex justify-end mb-0 pb-0 component"
        md="auto"
      >
      <AutocompleteSelect
        :props="autocomplete_filter"
        @update="update_filter"
      />
      <FileInput :props="{}" @update="load_file"></FileInput>
      </v-col>
    </v-row>
    <!-- DATA -->
    <v-row dense>
      <JsonViewer
        :json="current_bp"
        :readonly="readonly"
        :lang="lang"
        :is_mobile="is_mobile"
        :roles="roles"
        @update="update_json"
      />
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import ViewTitle from '@/components/ViewTitle'
  import AutocompleteSelect from '@/components/inputs/AutocompleteSelect'
  import JsonViewer from '@/components/bpcreator/JsonViewer';
  import BPApi from '@/api/Businessprocess';
  import BP from '@/qunit/BP';
  import LangSelector from '@/components/header/LangSelector';
  import Businessprocess from '@/api/Businessprocess';
  import FileInput from '@/components/inputs/FileInput';

  export default {
    components: {
      AutocompleteSelect,
      JsonViewer,
      ViewTitle,
      LangSelector,
      FileInput
    },
    
    name: 'BPCreator',
    
    props: {
    },
    
    data: () => ({
      selected_bp: null,
      current_bp: new BP({}),
      readonly: true,
      js_name: null,
      user_valid_tabs: {
        'isAdmin': [], // Will take all bp
        'isManager': ['model','roles','states','fiters','columns','transitions','inlines'],
        'user': ['nothing'],// The BPs doesn't have the property nothing
      },
      lang: 'es',
      is_mobile: false,
      bp_creation_data: {},
    }),
    
    computed: {
      ...mapState(['bpmap']),
      ...mapGetters(['isAdmin', 'isManager', 'centro_id']),
      normal_user() {
        return !this.isAdmin && !this.isManager;
      },

      bps() {
        return Object.values(this.bpmap._bps).map(it => ([it.reference,it.reference])).toSorted((a,b) => a[1] > b[1]);
      },

      autocomplete_filter() {
        return {
          cols: 12,
          component: "AutocompleteSelect",
          disabled: this.normal_user,
          empty_value: null,
          hidden: null,
          id: "business_process_include",
          items: this.bps,
          label: "Selecciona bp",
          multiple: false,
          value: this.selected_bp,
        }
      },

      valid_tabs() {
        let res = this.user_valid_tabs['user'];
        if (this.isAdmin) {
          res = Object.keys(this.current_bp);
        } else if (this.isManager) {
          res = this.user_valid_tabs['isManager'];
        }

        return res;
      },

      roles() {
        return {
          'isAdmin': this.isAdmin,
          'isManager': this.isManager,
          'user': !(this.isAdmin || this.isManager),
        }
      }

    },
    
    mounted() {
      Businessprocess.creation_bp_data()
        .then((data) => {
          this.creation_bp_data = data;

        });
    },
    
    methods: {
      change_name(name) {
        this.js_name = name;
      },

      update_filter(bp) {
        if (bp && bp != this.selected_bp) {
          this.selected_bp = bp;
          this.js_name = bp;

          if(bp) {
            BPApi.get(this.centro_id,bp).then(data => {
              this.current_bp = new BP(JSON.parse(data.business_process).business_process,this.lang,this.creation_bp_data)
            })
            this.readonly = true;
          } else {
            this.current_bp = new BP({},this.lang,this.creation_bp_data);
          }
        }
      },

      update_json(json) {
        this.current_bp = new BP(json, this.lang);
      },

      save_json() {
        const filename = this.js_name;
        const blob = new Blob([JSON.stringify({'business_process': this.current_bp.toJSON()}, null, 2)], {
          type: "application/json",
        });
        const ob = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = ob
        link.download = filename
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(ob)
        }, 100)
      },

      cancel() {
        this.readonly = !this.readonly;
      },

      change_lang(lang) {
        this.lang = lang;
        this.current_bp.change_lang(lang);
      },

      load_file(file) {
        if(file) {
          this.selected_bp = null;
          this.js_name = (file.name || '').split('.json')[0];

          file.text().then((some) => {
            this.update_json(JSON.parse(some).business_process || {});
          })
        }
      }
    },
  }
</script>